import { JANZU_URL } from "config/config";
import {
  DEFAULT_EXPLORE_DETECTOR_NAME,
  MAX_DETECTOR_NAME_LENGTH,
  MAX_DETECTOR_NAME_LENGTH_ERROR,
} from "config/constants";

export enum DetectorPrecheckNameError {
  AlreadyUsed = "already used",
}

export type DetectorPrecheckErrors = {
  name?: DetectorPrecheckNameError;
  valid: undefined;
};

type DetectorPrecheckResponse = { valid: true } | { valid: false; errors: DetectorPrecheckErrors };

export async function checkDetectorName(
  detectorName: string,
  detectorGroupId?: string
): Promise<DetectorPrecheckResponse> {
  const response = await fetch(`${JANZU_URL}reef-api/detectors/precheck`, {
    method: "POST",
    body: JSON.stringify({
      name: detectorName,
      group_id: detectorGroupId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();

  if (response.ok) {
    return {
      valid: true,
    };
  }

  return {
    valid: false,
    errors: data,
  };
}

/**
 * Returns any error found for the detector name. If no error is found an empty
 * string is returned.
 */
export async function getDetectorNameValidationError(detectorName: string, detectorGroupId?: string): Promise<string> {
  if (detectorName === "") {
    return "Detector name is required";
  }

  if (detectorName === DEFAULT_EXPLORE_DETECTOR_NAME) {
    return "This name is restricted only for explore detectors. Try another";
  }

  if (detectorName.length > MAX_DETECTOR_NAME_LENGTH) {
    return MAX_DETECTOR_NAME_LENGTH_ERROR;
  }

  const validation = await checkDetectorName(detectorName, detectorGroupId);

  if (validation.valid) {
    return "";
  }

  if (validation.errors.name === DetectorPrecheckNameError.AlreadyUsed) {
    return "A detector with that name already exists.";
  }

  return "";
}
